import _ from 'lodash'
import { UUID } from '@/plugins/common'

export default class ColorFormat {
  constructor (args = {}) {
    const defaults = {
      id: UUID.create(),
      columnId: '',
      warningWaySelect: 'data',
      type: '',
      color: '',
      condition: '',
      warningText: true
    }
    _.defaults(this, args, defaults)
  }
}



// WEBPACK FOOTER //
// ./src/store/report/colorFormat.js